import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

function TrainerClaimAlert({ message, errorCode, loginTo }) {
  if (!message) return null;

  if (errorCode === "ALREADY_CLAIMED") {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        {message}
        <Box mt={1} display="flex" justifyContent="center">
          <Button color="info" variant="outlined" size="small" component={RouterLink} to={loginTo}>
            Sign in
          </Button>
        </Box>
      </Alert>
    );
  }

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}

export default TrainerClaimAlert;
